<template>
    <span>{{ displayValue }}</span>
</template>

<script>
import {parseBoolean} from "@spoferan/spoferan-ts-core";
    export default {
        name: "DynamicInputValue",

        props: {
            value: {
				default: null
			},

            // The input data to display the value for
            input: {
                type: Object,
                required: true
            }
        },

        computed: {
            displayValue() {
                return this.parseValue(this.value);
            }
        },

        methods: {
            parseValue(value) {
                if (value === null || value === undefined) {
                    return '-';
                }
                if (Array.isArray(value)) {
                    return value.map(itValue => this.parseValue(itValue)).join(', ');
                }

                if (this.input.type && this.input.type.is_boolean) {
                    return parseBoolean(value) ? this.$t('label.yes') : this.$t('label.no')
                }

                if (this.input.type && this.input.type.value === 'date') {
                    return this.$date(value).format('LL');
                }

                return value;
            }
        }
    }
</script>